var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrokeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69064 5.05936C3.8615 5.23021 4.1385 5.23021 4.30936 5.05936L7.80936 1.55936C7.98021 1.3885 7.98021 1.1115 7.80936 0.940641C7.6385 0.769787 7.36149 0.769787 7.19064 0.940641L4 4.13128L0.809359 0.940641C0.638505 0.769787 0.361495 0.769787 0.190641 0.940641C0.0197864 1.1115 0.0197864 1.3885 0.190641 1.55936L3.69064 5.05936Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeDown);
export default __webpack_public_path__ + "static/media/Stroke-down.d7f195630edfd60ba37458d077730ef4.svg";
export { ForwardRef as ReactComponent };